import OutsideButton from '@gaia/components/OutsideButton';
import {outsidePlus} from '@gaia/images/logos';
import theme from '@gaia/theme';
import {Typography} from '@mui/material';
import {useContext} from 'react';

import outsideCollage from './outside-collage.png';
import {UpsellCarouselAnalyticsFunctionContext} from './UpsellCarousel';

export default function OutsidePaywallCard() {
    const fireAnalytics = useContext(UpsellCarouselAnalyticsFunctionContext); // Normally this would be fed as a prop, but we already use a context for the UpsellCardButtons and consistency is clarity.
    return (
        <>
            <div
                style={{
                    alignItems: 'center',
                    justifyContent: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    height: 480,
                    paddingTop: theme.spacing(5),
                }}
            >
                <img
                    style={{
                        width: 213,
                    }}
                    src={outsidePlus}
                    alt='Outside Plus'
                />
                <img
                    style={{
                        marginBottom: theme.spacing(4),
                        marginLeft: theme.spacing(2),
                        marginRight: theme.spacing(2),
                        marginTop: theme.spacing(4),
                        width: '100%',
                    }}
                    src={outsideCollage}
                    alt='Outside Plus benefits include access to Outside publications and Outside TV in addition to Gaia GPS'
                />
                <div
                    style={{
                        paddingLeft: theme.spacing(2),
                        paddingRight: theme.spacing(2),
                        paddingTop: theme.spacing(2),
                        textAlign: 'left',
                    }}
                >
                    <Typography
                        variant='body1'
                        style={{
                            lineHeight: 18 / 14,
                            marginBottom: theme.spacing(2),
                        }}
                    >
                        Get even more out of Gaia GPS by upgrading to Outside+. You get Gaia GPS
                        Premium plus award-winning outdoor content to fuel your adventures.
                    </Typography>
                </div>
            </div>
            <div style={{paddingTop: theme.spacing(2)}}>
                <OutsideButton
                    appearance='primary'
                    fullWidth
                    style={{height: theme.spacing(6)}}
                    href='/outsideplus/'
                    target='_blank'
                    rel='noopener'
                    onClick={() => fireAnalytics('Select - Subscribe to Outside+')}
                >
                    Subscribe to Outside+
                </OutsideButton>
            </div>
        </>
    );
}
